import React from "react";
import { AccordionItem } from "@/Components/AccordionItem";
import { BatteryCharging, Info, Link, PieChart, Truck } from "react-feather";

export function DefinitionOfScopes() {
  return (
    <AccordionItem
      title="Definition of scopes"
      titleStyle="text-[14px] ml-2"
      icon={<Info size={20} />}
      className="border"
    >
      <>
        <div className="flex w-full flex-wrap md:flex-nowrap md:gap-4">
          <div className="w-full border bg-white p-4 sm:w-1/2 md:w-1/4">
            <h6 className="mb-2 flex items-center justify-between font-bold">
              Scope 1
              <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#5D4634]`}>
                <Truck width={20} stroke="white" />
              </span>
            </h6>
            <p>
              <b className="font-bold">Direct emissions</b> that come from
              activities or processes that you control within your own
              organization.
            </p>
          </div>
          <div className="w-full border bg-white p-4 sm:w-1/2 md:w-1/4">
            <h6 className="mb-2 flex items-center justify-between font-bold">
              Scope 2
              <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#7E9CB3]`}>
                <BatteryCharging width={20} stroke="white" />
              </span>
            </h6>
            <p>
              <b className="font-bold">Indirect emissions</b> that come from the
              production of electricity, heat, or steam that your organization
              consumes.
            </p>
          </div>
          <div className="w-full border bg-white p-4 sm:w-1/2 md:w-1/4">
            <h6 className="mb-2 flex items-center justify-between font-bold">
              Scope 3
              <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#F96733]`}>
                <Link width={20} stroke="white" />
              </span>
            </h6>
            <p>
              <b className="font-bold">All other indirect</b> emissions that
              occur throughout the entire value chain of your organization.
            </p>
          </div>
          <div className="w-full border bg-white p-4 sm:w-1/2 md:w-1/4">
            <h6 className="mb-2 flex items-center justify-between font-bold">
              Out of scope
              <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#C4C4C4]`}>
                <PieChart width={20} stroke="white" />
              </span>
            </h6>
            <p>
              The things that are <b className="font-bold">not considered</b>{" "}
              within the specific analysis or discussion, for example biogenic
              emissions.
            </p>
          </div>
        </div>
      </>
    </AccordionItem>
  );
}
